import { Loader2 } from 'lucide-react';

import { useCustomerSettings } from '@/hooks/useCustomerSettings';
import { TeamSettings } from './panels';

/**
 * Settings → Team. People who can sign in to this account. Admins get the
 * invite form + remove action; members see the roster read-only.
 */
export default function TeamTab() {
  const { data, isLoading, error } = useCustomerSettings();

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 px-1 text-sm tracking-tight text-slate-900">
        <Loader2 size={14} className="animate-spin" /> Loading team…
      </div>
    );
  }
  if (error) {
    return (
      <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm tracking-tight text-red-700">
        {error instanceof Error ? error.message : 'Failed to load settings.'}
      </div>
    );
  }
  if (!data) return null;

  return <TeamSettings data={data} />;
}
